import { render } from "./DiagnosticoForm.vue?vue&type=template&id=61633622"
import script from "./DiagnosticoForm.vue?vue&type=script&lang=js"
export * from "./DiagnosticoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__